export default "<h1> Portal - Device OS </h1>\r\n<p>Provides an aggregated overview of the Device operating system types that were detected. </p>\r\n\r\n\r\n";